<template>
  <div>
    <div class="flex flex-row overflow-y-hidden overflow-x-scroll border-box h-full">
      <div ref='templateItems'
           class="h-full flex-none w-full flex flex-row"
           v-for='({component,transform,slot},i) in customizableComponents'
           :key='component.id'
           >
        <pbc-button v-if='i > 0' @click='gotoTemplateItem(i-1)' class='flex-none h-full pbc-primary-color'>
          <chevron-left />
        </pbc-button>

        <visible-listener @visible='onComponentVisible' :data='{component,transform}' class='grow px-4 h-full flex flex-col justify-center overflow-hidden'>
          <div v-if='slot' class='text-xs text-gray-400 font-semibold mb-1 truncate'>
            {{ slot.label }}<span v-if='slot.required' class='text-red-400 ml-1'>*</span>
          </div>
           <quick-edit class="w-full grow overflow-hidden"
                       :component='component'
                       :slot-info='slot'
                       :transform='viewingTransform'
                       :transforms-and-source='transformsAndSource'
                       :render-tools='renderTools'
                       :partutil='partutil'
                       :selections-data='selectionsData'
                       @change='onChange'
                       :holder-data='holderData'
                       @focus='onFocus'
                       @blur='onBlur'
                       @update='onUpdated'
                       @edit='$emit("edit", $event)'
                       />

          <!--
          <button class="relative underline text-white w-full h-full rounded border-0 p-3 text-lg bg-gray-800 flex flex-row justify-center"
              @click='onEdit(component, transform)'
                >

                <format-text v-if='!component.text' :size='32' class="pbc-button my-auto" />

                <div class="my-auto">{{component.text ? component.text : "Tap to enter text."}}</div>

          </button>
          -->
          <!--<p class="absolute left-0 top-0 text-gray-500 font-bold text-sm">{{i+1}}/{{customizableComponents.length}}</p>-->

        </visible-listener>

        <pbc-button v-if='i < customizableComponents.length-1' @click='gotoTemplateItem(i+1)' class="self-center pl-2 flex-none h-12 pbc-primary-color">
          Next
          <chevron-right />
        </pbc-button>
        <pbc-button v-else @click='$emit("post")' class="self-center pl-2 flex-none h-12 pbc-primary-color" :disabled='disablePostButton'>
          Preview
          <chevron-right />
        </pbc-button>
      </div>
    </div>
  </div>
</template>
<script>
import QuickEdit from '@ui/organisms/QuickEdit.vue';
//import FormatText from '@icons/FormatText.vue';
import { debounce, cloneDeep } from 'lodash';
import { mapState } from 'vuex';
import VisibleListener from '@ui/atoms/VisibleListener.vue';
import ChevronRight from '@icons/ChevronRight.vue';
import ChevronLeft from '@icons/ChevronLeft.vue';
export default {
  props:{
    template: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    viewingTransform: {
      type: Object,
      default() {
        return {}
      }
    },
    disablePostButton: {
      type: Boolean,
      default: false
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    selectionsData: {
      type: Array,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    }
  },
  components: {
    VisibleListener,
    ChevronRight,
    ChevronLeft,
    QuickEdit
    //FormatText
  },
  mounted() {
    if (this.viewingTransform.id) {
      this.selectOutsideItem();
    }
  },
  data() {
    console.log('TEMPLATE', this.template);
    const customizableComponents = this.template.components.map( ({component,transform,slot}) => {
      return {
        component: this.partutil.getComponentById(component),
        transform: this.partutil.findTransformById(transform),
        slot: slot || null
      }
    });
    const giveItSomeTimeHack = new Date().getTime();


    return {
      customizableComponents,
      giveItSomeTimeHack,
      visibleIndex:0,
      shadowComponent:{},
      currentComponent:{}
    }
  },
  methods: {
    onChange({nv,ov}) {
      this.$emit("change", {nv, ov, transform:this.viewingTransform});
    },
    onFocus() {
      this.$emit("keyboard-open");
    },
    onBlur() {
      this.$emit("keyboard-close");
    },
    gotoNextTemplateItem() {
      console.log('visible Index', this.visibleIndex);

      this.gotoTemplateItem(this.visibleIndex + 1);
    },
    onUpdated(component) {
      this.$emit('updated-component');
    },
    selectOutsideItem() {
      const id = this.viewingTransform.id;
      console.log('PRE SELECT THE FOKKEN THING', id);
      const index = this.template.components.findIndex( ({transform}) => {
        return transform === id;
      });
      if (index > -1) {
        this.gotoTemplateItem(index);
      }
    },
    gotoTemplateItem(index) {
      this.$refs.templateItems[index].scrollIntoView({
        //behavior:'smooth'
      });
    },
    onEdit(component, transform) {
      this.$emit("edit", {component, transform});
      this.$ana.track({
        eventCategory:'template',
        eventAction:'editComponent',
        extra:{
          templateId:this.template.id
        }
      });
    },
    onComponentVisible({visible,data}) {
      const now = new Date().getTime();

      this.shadowComponent = cloneDeep(data.component);
      this.currentComponent = data.component;

      if (false && this.viewingTransform.id && now - this.giveItSomeTimeHack < 3000) {
        setTimeout( () => {
          this.selectOutsideItem();
        }, 800);
        return;
      }

      if (visible) {
        this.visibleIndex = this.customizableComponents.findIndex( ({component}) => {
          return data.component.id === component.id;
        });
        this.$emit('view', {
          transform: data.transform,
          isLast: this.visibleIndex === this.customizableComponents.length - 1
        });
        this.$store.commit('setViewingTemplateItem', data.component.id);
        this.$ana.track({
          eventCategory:'template',
          eventAction:'viewComponent',
          extra:{
            templateId:this.template.id
          }
        });


      }

      /*
      return (visible) => {
      console.log('visibile', transform.id, visible);
      if (visible) {
        this.$emit('view', {transform});
      }
      }
      */
    }
  },
  computed: {
    ...mapState(['viewingTemplateItem'])
  },
  watch:{
    'viewingTransform.id'() {
      this.selectOutsideItem();
    }
  }
}
</script>
<style>
.template-customize-list {
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling:touch;
}
.template-customize-entry {
  scroll-snap-align: start;
  scroll-snap-stop: always;
}
</style>
